type PairingConnectedProps = {
  screenName: string;
  locationLabel: string | null;
};

export function PairingConnected({ screenName, locationLabel }: PairingConnectedProps) {
  return (
    <main className="pairing-main pairing-main--connected">
      <span className="pairing-connected__badge">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="m5 12.5 4.5 4.5L19 7.5"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Screen connected
      </span>
      <h1 className="pairing-connected__title">{screenName}</h1>
      <p className="pairing-connected__lede">
        {locationLabel ? `${locationLabel}. ` : null}
        Your content will start in a moment.
      </p>
    </main>
  );
}
